import React, { useState, useEffect } from "react";
import Select from "react-select";

// import QrReader from "react-qr-reader"; 
import { fetchData } from "../../networkRequests";

import LoadingSpinner from "../../../../images/login/spinner-min.gif";


import { MdMailOutline } from "react-icons/md";
import { IoIosMegaphone, IoIosDocument } from "react-icons/io";
import { setCookie, reversibleHash, socket, RelevantIcon, getCookie, detectBrowser } from "../../../oro-module/commonFunctions";
import "./styles.css";


import moment from "moment";
import QrReader from "react-qr-reader";

import {
  Button,
  Input
} from "reactstrap";
// import CameraCustom from "../../FormComponents/CameraCustom";
import { AutocompleteCustom, SelectCustom } from "../../../FormComponents";
import { PortalSelect } from "./PortalSelect";
import { OTPLogin } from "./OTPLogin";
import { UserPassLogin } from "./UserPassLogin";
import { QRCodeLogin } from "./QRCodeLogin";
import { LoginButton } from "./LoginButton";
import { serverLogin } from "./serverLogin";



const LoggingInGIF = () => {
  return <div style={{ textAlign: "center", marginTop: 20 }}><img width="50" src={LoadingSpinner} /></div>
}

const client_uri = window.location.href;
// const client_uri = "https://192.168.40.150:5123/login"
// const client_uri = "https://testcbs.jaysahakar.com/login"
//const client_uri = "https://pdcc.jaysahakar.com/login"
// const client_uri = "https://pdccbank.jaysahakar.com/login" // CBS, legacy reports, attendance, payroll, ticketing
// const client_uri = "https://dmpl.jaysahakar.com/login" // ticketing portals
// const client_uri = "https://harcoeportal.in/login"
//const client_uri = "https://pcmc.jaysahakar.com/login"
//const client_uri = "https://gcparbhani.jaysahakar.com/login"


const Login = (props) => {

  let [username, setusername] = useState();
  let [password, setpassword] = useState();
  let [newpass, setnewpass] = useState();
  let [renewpass, setrenewpass] = useState();
  let [message, setmessage] = useState();
  let [isloading, setloading] = useState(false);
  let [showloginbtn, setshowloginbtn] = useState(false);
  let [forcereset, setforcereset] = useState(false);
  const [width, setWidth] = useState(window.screen.width);

  let [allowed_authentication_types, setallowed_authentication_types] = useState({});

  let [allportals, setallportals] = useState([]);
  let [background_url, setbackground_url] = useState(false);
  let [logo_url, setlogo_url] = useState([]);
  let [welcome_text, setwelcome_text] = useState("");

  let [isLoggingIn, setisLoggingIn] = useState(false);
  let [strokes, setstrokes] = useState([]);
  let [portal, setportal] = useState();
  let [portalscheme, setportalscheme] = useState();
  let [issuspecious, setissuspecious] = useState(false);
  let [currentLoginType, setcurrentLoginType] = useState('userpass');
  let isloaded = false;
  let { remoteip } = props.parentState;





  const setClientVariables = (data) => {
    if (data.reply && data.reply.portals && data.reply.portals.length > 0) {
      let { background_uri, logo_uri, icon_uri, welcome_text, portals } = data.reply;
      let ap = [];
      let auth_types = {};
      portals.map(p => {
        ap.push({ label: p.description, value: p.portal_code, active: true, scheme: p.portal_scheme_code });
        auth_types[p.portal_scheme_code] = { allow_otp: p.allow_otp, allow_userpass: p.allow_userpass, allow_qr: p.allow_qr };
      })
      setallportals(ap);
      setwelcome_text(welcome_text);
      setbackground_url(background_uri);
      setlogo_url(logo_uri);
      setallowed_authentication_types(auth_types);
      props.liftGlobalState({ name: "icon_url" }, icon_uri);
      props.liftGlobalState({ name: "logo_url" }, logo_uri);
      isloaded = true;
    } else {
      // JS default logo and background.

      setTimeout(() => {
        if (!isloaded) {
          let ap = [{ "label": "Admin", value: "Admin", active: true, scheme: "Admin" }];
          let auth_types = { Admin: { allow_otp: true, allow_userpass: true, allow_qr: false } };

          // let ap = [{ "label": "cbs", value: "cbs", active: true, scheme: "cbs" }];
          // let auth_types = { cbs: { allow_otp: true, allow_userpass: true, allow_qr: false } };
          // let ap = [{ "label": "M&P Reports", value: "apexreport", active: true, scheme: "apexreport" }];
          // let auth_types = { apexreport: { allow_otp: false, allow_userpass: true, allow_qr: false } };

          setallportals(ap);
          setwelcome_text("");
          setbackground_url("https://s3.ap-south-1.amazonaws.com/parbhanidccbank.com/background1.jpg");
          setlogo_url("https://s3.ap-south-1.amazonaws.com/jaysahakar.com/mascot_large.svg");
          props.liftGlobalState({ name: "icon_url" }, "https://s3.ap-south-1.amazonaws.com/jaysahakar.com/js-icon.svg");
          setallowed_authentication_types(auth_types);
        }
      }, 60000);
    }
  }

  useEffect(() => {
    setloading(true);

    let brow = detectBrowser();
    if (brow == 'chrome') {
      let saveThis = { client_uri };
      setClientVariables({});
      setloading(false);
      fetchData({ url: 'clientdata', postData: saveThis, method: "post", current: { props }, cbf: setClientVariables });
    } else {
      alert("Browser is not supported. Please install the latest version of Google Chrome.");
    }
  }, []);


  const setvals = (vals) => {
    setportal(vals.value);
    setportalscheme(vals.scheme);
    if (allowed_authentication_types[vals.scheme]['allow_userpass']) {
      setcurrentLoginType('userpass');
    } else if (allowed_authentication_types[vals.scheme]['allow_otp']) {
      setcurrentLoginType('otp');
    } else if (allowed_authentication_types[vals.scheme]['allow_qr']) {
      setcurrentLoginType('qrcode');
    }
  }



  const onLoginPress = () => {
    let orosession = getCookie("orosession");
    if (orosession && orosession != "[]") {
      let msg = "Already logged in. Would you like to logout all the other sessions and start fresh?";
      let feedback = window.confirm(msg);
      if (feedback) {
        localStorage.clear();
        window.location = "/";
      }
      return false;
      // window.location = "/";
    } else {
      setisLoggingIn(true);
      let options = { username, password, newpass, renewpass, strokes, currentLoginType, portal, portal_scheme: portalscheme };
      console.log({ options });
      if (!username || !password) {
        alert("Fill all values");
        setisLoggingIn(false);
      } else {
        serverLogin({ props, options, client_uri, setisLoggingIn, setmessage, setforcereset });
      }
    }
  }

  return (
    <div>
      {isloading &&
        <div className="fullpage-loading-container">
          <div className="fullpage-loading">
            Loading . . .
          </div>
        </div>
      }
      {!isloading &&
        <div className="row" style={{
          width: "100%", height: "100vh", margin: 0,
          backgroundImage: `url(${background_url})`, backgroundBlendMode: "screen", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center", overflow: "hidden"
        }}>

          <div className="col-sm-12 col-lg-3 col-md-1" style={{ color: "white" }}> {/*d-none d-sm-block*/}
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-12"></div>
            </div>
          </div>


          <div className="col-sm-12 col-lg-6 col-md-10 login-area-container">

            <div className="welcome_text_container"
            // style={{ height: welcome_text && (welcome_text.split("\\n").length > 2) ? 150 : 100 }}
            >
              {welcome_text &&
                <div className="welcome_text col-sm-12">{welcome_text.split("\\n").map((d, idx) => <div key={idx}>{d}</div>)}</div>
              }
            </div>

            <div className="login-container" >
              <div className="col-sm-12 logo-container">
                <img style={{ maxHeight: 200, maxWidth: "100%", marginTop: 30 }} src={logo_url} />
              </div>

              {!portal &&
                <PortalSelect props={props} is_mobile={width < 500} allportals={allportals} setvals={setvals} setportal={setportal} setportalscheme={setportalscheme} />
              }

              {portal &&
                <div>
                  <div className="row" style={{ marginBottom: 20, marginTop: 20 }}>
                    {allowed_authentication_types[portalscheme]['allow_userpass'] &&
                      <div className="col-sm-6 auth_btn_container">
                        <span onClick={() => setcurrentLoginType('userpass')} className={`auth_btn ${currentLoginType == 'userpass' ? 'auth_btn_selected' : ''}`}>Username & Password</span>
                      </div>
                    }
                    {allowed_authentication_types[portalscheme]['allow_otp'] &&
                      <div className="col-sm-6 auth_btn_container">
                        <span onClick={() => setcurrentLoginType('otp')} className={`auth_btn ${currentLoginType == 'otp' ? 'auth_btn_selected' : ''}`}>One Time Password</span>
                      </div>
                    }
                    {allowed_authentication_types[portalscheme]['allow_qr'] &&
                      <div className="col-sm-4 auth_btn_container">
                        <span onClick={() => setcurrentLoginType('qrcode')} className={`auth_btn ${currentLoginType == 'qrcode' ? 'auth_btn_selected' : ''}`}>QR</span>
                      </div>
                    }
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      {currentLoginType == 'userpass' &&
                        <UserPassLogin options={{ username, password, strokes, setusername, setpassword, setstrokes, newpass, renewpass, setnewpass, setrenewpass }} setmessage={setmessage} handleLogin={onLoginPress} forcereset={forcereset} />
                      }

                      {currentLoginType == 'otp' &&
                        <OTPLogin autoFocus={true} options={{ username, password, strokes, setusername, setpassword, setstrokes }} setmessage={setmessage} handleLogin={onLoginPress} props={props} portal={portal} />
                      }

                      {currentLoginType == 'qrcode' &&
                        <QRCodeLogin options={username, password, strokes, setusername, setpassword, setstrokes} remoteip={remoteip} setmessage={setmessage} />
                      }

                      {/* {this.state.suspecious &&
                      <div className="col-sm-12" style={{ textAlign: "center", marginTop: 10 }}>
                        <RelevantIcon icon="face-reco" style={{ color: this.state.isfaceauth ? "#E56376" : "gray", fontSize: 40 }} />
                        <RelevantIcon icon="fingerprint" style={{ color: this.state.isfingerauth ? "#E56376" : "gray", fontSize: 40 }} />
                      </div>
                    } */}

                      <div className="col-sm-12" style={{ paddingBottom: 20 }}>
                        <LoginButton isLoggingIn={isLoggingIn} logo_url={logo_url}
                          handleLogin={onLoginPress}
                        />
                      </div>

                      <div className="col-sm-12" style={{ paddingBottom: 20 }}>
                        <div className="error-message">{message}</div>
                      </div>

                      {portal &&
                        <div className="back-btn-container"><span className="hand" onClick={() => setportal(false)}><RelevantIcon icon="back-arrow" style={{ color: "darkorange", fontSize: 60 }} /></span></div>
                      }

                    </div>
                  </div>
                </div>
              }
            </div>

            <div className="powered-by-container">
              {window.location.href.indexOf('harco') == -1 &&
                <div className="powered-by">
                  © Decision Machines Private Limited
                </div>
              }
            </div>


          </div>

          <div className="col-sm-12 col-lg-3 col-md-1" style={{ color: "white" }}> {/*d-none d-sm-block*/}
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-12"></div>
            </div>
          </div>
        </div>
      }
    </div>
  );

}


export default Login;